import { FC, MouseEvent, useMemo } from 'react';
import { DropdownOption } from '../../../lib/Dropdown/types';
import { Icon } from '../../Icon';

export type MultiselectItemProps = {
  /**
   * Item for this component
   */
  item: DropdownOption;
  /**
   * Flag for disabled
   */
  disabled?: boolean;
  /**
   * Click function for closing
   */
  onRemove?: (item: DropdownOption) => void;
};

const BASE_MULTISELECTITEM_CLASSES = 'flex px-2 rounded inline-block mr-2 mb-2';
const DEFAULT_MULTISELECTITEM_CLASSES = `${BASE_MULTISELECTITEM_CLASSES} bg-violet-200 text-white`;
const DISABLED_MULTISELECTITEM_CLASSES = `${BASE_MULTISELECTITEM_CLASSES} bg-gray-200 text-gray-500`;

export const MultiselectItem: FC<MultiselectItemProps> = ({
  item,
  disabled,
  onRemove,
}: MultiselectItemProps) => {
  const multiselectItemClassName = useMemo(
    () =>
      disabled
        ? DISABLED_MULTISELECTITEM_CLASSES
        : DEFAULT_MULTISELECTITEM_CLASSES,
    [disabled],
  );
  return (
    <div className={multiselectItemClassName} style={{ paddingTop: '2px' }} data-testid="dropdown-multiselect-selected-item">
      {item?.name}
      {onRemove && (
        <a
          data-testid="dropdown-multiselect-selected-item-close"
          href="#"
          className={`ml-3 flex flex-col justify-center items-center`}
          style={{ marginTop: '-2px' }}
          onClick={(event: MouseEvent | TouchEvent) => {
            event.preventDefault();
            event.stopPropagation();
            if (!disabled) {
              onRemove(item);
            }
          }}
        >
          <span className={`w-4`}>
            <Icon name="Close" />
          </span>
        </a>
      )}
    </div>
  );
};
